import React  from 'react';
import ReactDOM from 'react-dom'

import { Button, notification, Progress, message } from 'antd';
import { SmileOutlined } from '@ant-design/icons';

import uuid from './uuid';

class DownloadFile {
    downloadingCount = 0
    destoryCount = 0
    openNotification = ()=>{
        const key = uuid();
        notification.open({
          message: '下载中',
          description:
            '...',
          icon: <SmileOutlined style={{ color: '#108ee9' }} />,
          duration: null,
            key,
            closeIcon: <div></div>,
        });
        const thisKey = this.downloadingCount + 1;
        this.downloadingCount = thisKey;
        return new Promise(resolve=>{
            const timerId = setInterval(()=>{
                const all = document.querySelectorAll('.ant-notification-notice');
                if(all.length > 0 && all.length === this.downloadingCount - this.destoryCount){
                    resolve([all[thisKey - this.destoryCount - 1], key]);
                    clearInterval(timerId);
                }
            }, 100);
            // setTimeout(()=>{
            //     const all = document.querySelectorAll('.ant-notification-notice');
            //     console.log(all);
            //     resolve([all[all.length - 1], key])
            // }, 300);
        });
    }
    run = async (downloadUrl)=>{
        if(!downloadUrl) return;
        const [dom, notificationKey] = await this.openNotification();
        const xhr = new XMLHttpRequest();
        xhr.open("GET", downloadUrl, true);
        xhr.responseType = 'blob';
        xhr.onload = (e)=>{
            setTimeout(()=>{
                notification.close(notificationKey);
                this.destoryCount++;
            }, 2000);
            var url = window.URL.createObjectURL(xhr.response)
            var a = document.createElement('a');
            a.href = url
            a.download = ''
            a.click()
        }
        xhr.onerror = ()=>{
            message.error('下载失败，请使用右键“另存为”下载');
            notification.close(notificationKey);
            this.destoryCount++;
        }
        xhr.addEventListener('progress', evt=>{
            const total = evt.total;
            const loaded = evt.loaded;
            ReactDOM.render(
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                }}>
                    <Progress percent={Math.floor(loaded/total*100)} showInfo={false} />
                    <div style={{
                        marginLeft: 4
                    }}>{(loaded/1024/1024).toFixed(1)}M/{(total/1024/1024).toFixed(1)}M</div>
                </div>,
  
                dom.querySelector('.ant-notification-notice-description')
            )
        });
        xhr.send();
    }
}

const downloader = new DownloadFile();

export default function downloadFile(url){
    const target = url.startsWith('http:') ? url.replace('http:', 'https:') : url;
  downloader.run(target);
}